
import { Injectable } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { CART_Has_Error, CART_LIST_SELECTOR, CART_TOTAL_SELECTOR, LOADING_CART_SELECTOR } from "./store/cart.selectors";
import { HttpClient } from "@angular/common/http";
import { CookieService } from "ngx-cookie-service";
import { CART_Loading, FETCH_CART_ACTION, REMOVE_FROM_CART_ACTION, REQUEST_ADD_TO_CART_ACTION, REQUEST_CART_TOTAL_ACTION, UPDATE_CART_ACTION } from "./store/cart.action";
import { Observable } from "rxjs";
import { RequestCartItemInterface } from "../Entites/cart.model";
import { CartItemInterface } from "../Entites/product.model";
import { FacebookPixelService, GoogleAnalyticsService, TiktokPixelService, add_to_cart_option_interface } from "imakeapp-shared";
import { UPDATE_CART_DISPLAY_STATUS_ACTION } from "imakeapp-header-themes";




@Injectable({ providedIn: 'root' })
export class CartFacade
{

  product_quantity: number = 1;
  FetchCart$: Observable<CartItemInterface[]> = this.store.select(CART_LIST_SELECTOR);
  LoadingCart$: Observable<boolean> = this.store.select(LOADING_CART_SELECTOR);
  ErrorCart$: Observable<string> = this.store.select(CART_Has_Error);

  constructor(
    private store: Store<any>,
    private cookie_s: CookieService,
    private fb_pixel_s: FacebookPixelService,
    private google_analytic_s: GoogleAnalyticsService,
    private tiktok_pixel_s: TiktokPixelService
  ) {}

    CART_TOTAL$: Observable<number> = this.store.select(CART_TOTAL_SELECTOR);


  RequestCart()
  {


    this.store.dispatch(new FETCH_CART_ACTION())
    this.store.dispatch(new CART_Loading(true))
this.requestCartTotal()


  }




  add_to_cart(CartDATA:RequestCartItemInterface)
  {

  console.log("add to cart")
  CartDATA.code = this.cookie_s.get('cart_code') ? this.cookie_s.get('cart_code') : this.generate_randon_code(10),
  this.store.dispatch( new REQUEST_ADD_TO_CART_ACTION(CartDATA!!) );
  this.store.dispatch(new CART_Loading(true));

  }


  init_analytic(analytic_options: add_to_cart_option_interface)
  {

    // facebook pixel
    this.fb_pixel_s.addToCart(analytic_options);

    // google analytics
    this.google_analytic_s.addToCart({
      currency: analytic_options.currency,
      value: analytic_options.value,
      items: [
        {
          item_id: analytic_options.item_id,
          item_name: analytic_options.content_name,
          price: analytic_options.value,
          quantity: analytic_options.num_items
        }
      ]
    });

    // tiktok pixel
    this.tiktok_pixel_s.addToCart({
      content_id: String(analytic_options.item_id),
      content_name: analytic_options.content_name,
      descriptions: analytic_options.content_name,
      quantity: analytic_options.num_items,
      price: analytic_options.value,
      value: analytic_options.value,
      currency: analytic_options.currency
    });

  }





  generate_randon_code(length: number)
  {

    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    this.cookie_s.set('cart_code',result,undefined,'/')
    return result;

  }

  requestCartTotal()
  {
    this.store.dispatch( new REQUEST_CART_TOTAL_ACTION() );

  }




  delete_cart_item(cart_id: number)
  {
    this.store.dispatch( new REMOVE_FROM_CART_ACTION(cart_id) );
  }




  update_cart_item(cart_id: number, amount_select_el: any)
  {

    let new_amount = amount_select_el;

console.log(new_amount)
  this.store.dispatch( new UPDATE_CART_ACTION({ cart_id: cart_id , new_amount: new_amount }) );
}



  display_cart(state: boolean)
  {
    this.store.dispatch(new UPDATE_CART_DISPLAY_STATUS_ACTION(state) );
  }


}
